export const getSlidesQuantity = (): number => {
  const isClient = typeof window === 'object';
  const width = isClient ? window.innerWidth : 1366;
  if (width < 768) return 2;
  if (width >= 768 && width <= 1280) return 3;
  if (width > 1280) return 4;
  return 4;
};
